import type { ApiServiceContainer } from '@@/api/services/ApiServiceContainer'

export default function () {
  const { $api } = useNuxtApp()

  return $api as ApiServiceContainer
}
